import { createSlice } from '@reduxjs/toolkit';

export const numberSlice = createSlice({
  name: 'numbers',
  initialState: {
    selectedUnassignedNumber: {},
    openUnassignedNumberForm: false,
    selectedAssignedNumber: {},
    openAssignedNumberForm: false,
    numberType :'',
    numbersToast: {
      status: null,
      message: "",
    }
  },
  reducers: {
    setSelectedUnassignedNumber: (state, action) => {
      state.selectedUnassignedNumber = action.payload;
    },
    setOpenUnassignedNumberForm: (state, action) => {
      state.openUnassignedNumberForm = action.payload;
    },
    setNumbersToast: (state, action) => {
      state.numbersToast = action.payload;
    },
    setSelectedAssignedNumber: (state, action) => {
      state.selectedAssignedNumber = action.payload;
    },
    setOpenAssignedNumberForm: (state, action) => {
      state.openAssignedNumberForm = action.payload;
    },
    setNumberType: (state, action) => {
      state.numberType = action.payload;
    }
  }
});

export const {
  setSelectedUnassignedNumber,
  setOpenUnassignedNumberForm,
  setNumbersToast,
  setSelectedAssignedNumber,
  setOpenAssignedNumberForm,
  setNumberType
} = numberSlice.actions

export default numberSlice.reducer;